import { render, staticRenderFns } from "./DealerSalespersonPendingWidget.vue?vue&type=template&id=0fe2cb14"
import script from "./DealerSalespersonPendingWidget.vue?vue&type=script&lang=js"
export * from "./DealerSalespersonPendingWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports